import { RootState } from '../../../../shared/config/store'
import { recentlyDeletedSelectors } from '../slice/recentlyDeletedSlice'


export const allTrashedNodesSelector = (state: RootState) => recentlyDeletedSelectors.selectAll(state.recentlyDeleted)

export const recentlyDeletedSelector = (state: RootState) => state.recentlyDeleted

export const recentlyDeletedStatusSelector = (state: RootState) => state.recentlyDeleted.status

export const recentlyDeletedErrorSelector = (state: RootState) => state.recentlyDeleted.error

export const recentlyDeletedAreAllTrashedNodesFetchedSelector = (state: RootState) => state.recentlyDeleted.areAllTrashedNodesFetched